import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import web5 from "../img/hotelp.jpg";
import "../style/styles.css";
import "../style/Hotelsof.css";

const Hotelsof = () => {
  const quickStats = [
    { value: "PMS", label: "Property Management" },
    { value: "POS", label: "Restaurant Billing" },
    { value: "GST", label: "Inclusive / Exclusive" },
    { value: "ERP", label: "Hotel Operations" },
  ];

  const pricingOptions = [
    {
      title: "Desktop Application",
      price: "₹75,000/- + GST",
      note:
        "For single-location hotel PMS, POS, inventory and accounting operations.",
      terms: false,
    },
    {
      title: "Web Application",
      price: "₹1,35,000/- + GST",
      note:
        "Full web-based application for complete PMS Software workflow.",
      terms: true,
    },
  ];

  const coreFeatures = [
    {
      title: "Front Office & Reservation",
      text:
        "Manage room reservation, individual and group bookings, check-in, check-out, room availability, travel agents, corporate rates and plan-wise tariff control.",
    },
    {
      title: "GST Billing Flexibility",
      text:
        "Supports exclusive and inclusive GST/tax calculation flexibility for hotels, motels, resorts and restaurant operations.",
    },
    {
      title: "Housekeeping Control",
      text:
        "One-click housekeeping actions with room status visibility help reduce staff pressure and improve room readiness tracking.",
    },
    {
      title: "Food & Beverage POS",
      text:
        "Touch POS and Android app support for order generation and billing from mobile and tablet with complete front-office integration.",
    },
    {
      title: "Inventory Management",
      text:
        "Complete inventory cycle from indent, purchase order, approvals and GRN to material requests, issues, vendor management and accounts payable.",
    },
    {
      title: "Recipe Management",
      text:
        "Detailed recipe costing with ingredient cost control and costing options based on stock transfer for restaurant and kitchen operations.",
    },
  ];

  const operations = [
    "Room reservation and availability management",
    "Check-in and check-out status",
    "Room upgrade and room transfer workflow",
    "Company, travel agent and plan-wise tariff control",
    "Guest ledger and due reporting",
    "Room sales register and GST reports",
    "Guest history and booking search",
    "Night audit and occupancy analysis",
  ];

  const hospitalityModules = [
    {
      title: "Financial Accounting",
      text:
        "Complete financial accounting with cash book, bank book, receivables, payables and final accounting reports.",
    },
    {
      title: "SMS Alerts",
      text:
        "Guest SMS alerts for booking confirmation, check-in and checkout, plus management SMS for operations and daily sales.",
    },
    {
      title: "Banquet Management",
      text:
        "Banquet hall definition, hall reservation, tentative reservation, multiple date booking, hourly availability, advance, set menu, banquet KOT and billing.",
    },
    {
      title: "Laundry Management",
      text:
        "Guest laundry collection, staff chargeable laundry, express laundry, issue to vendor, return from vendor, laundry billing and settlement modes.",
    },
  ];

  const advancedFeatures = [
    {
      title: "QR Code Digital Menu",
      text:
        "Guests can scan a QR code and place food orders from restaurant tables or hotel rooms using their smartphones, reducing physical menus and manual interaction.",
    },
    {
      title: "Android Ordering App",
      text:
        "Digital ordering through Android app supports table and room ordering with smooth restaurant and front-office integration.",
    },
    {
      title: "HR & Attendance",
      text:
        "HotelSof HR module supports user-friendly employee management and Android app face recognition attendance without complicated hardware.",
    },
    {
      title: "User Access Control",
      text:
        "HR and accounting modules are linked with financial control and user access control for stronger operational discipline.",
    },
  ];

  const seoKeywords = [
    "Hotel Management Software",
    "Hotel PMS Software",
    "Property Management System Software",
    "Hotel Property Management Software",
    "Hotel ERP Software",
    "Hotel Billing Software",
    "Hotel Front Office Software",
    "Hotel Reservation Software",
    "Room Booking Software",
    "Room Reservation Software",
    "Check-in Checkout Software",
    "Hotel Guest Management Software",
    "Guest Ledger Software",
    "Hotel Housekeeping Software",
    "Hotel Room Status Software",
    "Hotel Tariff Management Software",
    "Hotel Occupancy Report Software",
    "Night Audit Software for Hotels",
    "Hotel GST Billing Software",
    "GST Enabled Hotel Software",
    "Motel Management Software",
    "Resort Management Software",
    "Restaurant POS Software",
    "Restaurant Billing Software",
    "Restaurant Management Software",
    "Food and Beverage POS Software",
    "F&B POS Software",
    "Restaurant KOT Software",
    "Kitchen Order Ticket Software",
    "Restaurant Table Management Software",
    "Restaurant Order Management Software",
    "Restaurant Inventory Software",
    "Restaurant Recipe Costing Software",
    "Recipe Management Software",
    "QR Code Menu Software",
    "Digital Menu Software",
    "Android Restaurant Ordering App",
    "Waiter Ordering App",
    "Room Service Ordering Software",
    "Hotel Inventory Management Software",
    "Hotel Purchase Management Software",
    "Hotel Accounting Software",
    "Hotel Financial Accounting Software",
    "Banquet Management Software",
    "Banquet Booking Software",
    "Laundry Management Software",
    "Hotel HR Software",
    "Hotel Attendance Software",
    "Face Recognition Attendance for Hotel",
    "Hotel Software in India",
    "Restaurant Software in India",
    "PMS Software for Hotels",
    "POS Software for Restaurants",
  ];

  const relatedSearchGroups = [
    {
      title: "Hotel PMS & Front Office",
      text:
        "Professional hotel PMS and property management solutions for reservation, room booking, check-in, checkout, guest ledger, tariff control, occupancy analysis and GST-enabled hotel billing.",
      terms: [
        "Hotel Management System",
        "Hotel Management Software",
        "Hotel PMS Software",
        "Property Management System Software",
        "Hotel Property Management Software",
        "Hotel ERP Software",
        "Hotel Front Office Software",
        "Hotel Reservation Software",
        "Room Booking Software",
        "Room Reservation Software",
        "Check-in Checkout Software",
        "Hotel Guest Management Software",
        "Hotel Guest Ledger Software",
        "Hotel Housekeeping Software",
        "Hotel Room Status Software",
        "Hotel Tariff Management Software",
        "Hotel Occupancy Report Software",
        "Night Audit Software for Hotels",
        "Hotel GST Billing Software",
        "GST Enabled Hotel Software",
      ],
    },
    {
      title: "Restaurant POS & Digital Ordering",
      text:
        "Restaurant software solutions for billing, KOT, table order, room service order, QR code menu, digital menu, waiter ordering app and Android restaurant ordering.",
      terms: [
        "Restaurant Software",
        "Restaurant POS Software",
        "POS Software for Restaurants",
        "Restaurant Billing Software",
        "Restaurant Management Software",
        "Food and Beverage POS Software",
        "F&B POS Software",
        "Restaurant KOT Software",
        "Kitchen Order Ticket Software",
        "Restaurant Table Management Software",
        "Restaurant Order Management Software",
        "QR Code Menu Software",
        "Digital Menu Software",
        "Android Restaurant Ordering App",
        "Waiter Ordering App",
        "Room Service Ordering Software",
      ],
    },
    {
      title: "Inventory, Accounting & Operations",
      text:
        "Integrated hotel ERP modules for inventory, purchase, recipe costing, banquet, laundry, HR, attendance, accounting and financial management.",
      terms: [
        "Hotel Inventory Management Software",
        "Hotel Purchase Management Software",
        "Restaurant Inventory Software",
        "Restaurant Recipe Costing Software",
        "Recipe Management Software",
        "Hotel Accounting Software",
        "Hotel Financial Accounting Software",
        "Banquet Management Software",
        "Banquet Booking Software",
        "Laundry Management Software",
        "Hotel HR Software",
        "Hotel Attendance Software",
        "Face Recognition Attendance for Hotel",
      ],
    },
    {
      title: "Software Searches by Location",
      text:
        "HotelSof is suitable for hotels, motels, resorts, restaurants and hospitality businesses looking for hotel software and restaurant software in Siliguri, West Bengal and India.",
      terms: [
        "Hotel Management Software in Siliguri",
        "Hotel Management Software in West Bengal",
        "Hotel Management Software in India",
        "Restaurant Software in Siliguri",
        "Restaurant Software in West Bengal",
        "Restaurant Software in India",
        "Hotel Software Company in Siliguri",
        "Restaurant Software Company in Siliguri",
        "Hotel Software Developer in West Bengal",
        "Restaurant Billing Software in India",
        "Hotel Software in India",
        "Restaurant Software in India",
        "Motel Management Software",
        "Resort Management Software",
      ],
    },
  ];

  const seoPainPoints = [
    {
      title: "Control hotel front office from one PMS",
      text:
        "HotelSof helps hotels manage room reservation, check-in, checkout, guest history, room status, occupancy, tariff, room sales and guest ledger from one property management system.",
    },
    {
      title: "Fast restaurant billing and KOT workflow",
      text:
        "HotelSof restaurant POS software supports table order, room order, food billing, GST billing, KOT, Android ordering app and QR code digital menu for smooth restaurant operations.",
    },
    {
      title: "Better inventory and recipe cost control",
      text:
        "HotelSof manages indent, purchase order, GRN, material issue, vendor management, restaurant inventory, recipe costing and ingredient cost control for kitchen and store operations.",
    },
    {
      title: "Integrated accounting and hospitality modules",
      text:
        "HotelSof connects PMS, POS, banquet, laundry, inventory, HR, attendance and financial accounting for complete hotel ERP control.",
    },
  ];

  const faqList = [
    {
      question: "What is HotelSof hotel PMS software?",
      answer:
        "HotelSof is a hotel PMS and hotel management software for hotels, motels and resorts. It manages room reservation, check-in, checkout, front office, restaurant POS, GST billing, housekeeping, inventory, banquet, laundry, HR and accounting.",
    },
    {
      question: "Does HotelSof include restaurant POS software?",
      answer:
        "Yes. HotelSof includes restaurant POS software for food and beverage billing, KOT, table order, room order, QR code digital menu, Android ordering app and GST billing.",
    },
    {
      question: "Can HotelSof manage hotel room reservation and checkout?",
      answer:
        "Yes. HotelSof manages room reservation, room availability, check-in, checkout, room transfer, room upgrade, guest history, guest ledger, occupancy analysis and room sales reporting.",
    },
    {
      question: "Does HotelSof support hotel inventory and recipe costing?",
      answer:
        "Yes. HotelSof supports hotel inventory management, indent, purchase order, approval, GRN, material issue, vendor management, accounts payable and recipe costing for restaurant and kitchen operations.",
    },
    {
      question: "Is HotelSof useful for hotels with banquet and laundry?",
      answer:
        "Yes. HotelSof includes banquet management and laundry management modules for banquet booking, hall reservation, banquet billing, laundry collection, vendor issue, laundry return, billing and settlement.",
    },
  ];

  const siteUrl = (process.env.REACT_APP_SITE_URL || "https://ebssoftware.co.in").replace(/\/$/, "");
  const pagePath = "/Hotelsof";
  const pageUrl = `${siteUrl}${pagePath}`;
  const heroImageUrl = String(web5 || "").startsWith("http") ? web5 : `${siteUrl}${web5}`;

  const seoTitle =
    "Hotel PMS Software | HotelSof Restaurant POS, Billing, Reservation & Accounting";

  const seoDescription =
    "HotelSof is a GST-enabled hotel PMS software and restaurant POS software for room reservation, check-in, checkout, restaurant billing, KOT, QR menu, inventory, banquet, laundry, HR and accounting.";

  const softwareSchema = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    name: "HotelSof",
    alternateName: "HotelSof Hotel PMS and Restaurant POS Software",
    applicationCategory: "BusinessApplication",
    operatingSystem: "Windows, Web, Android",
    url: pageUrl,
    image: heroImageUrl,
    description: seoDescription,
    brand: {
      "@type": "Brand",
      name: "HotelSof",
    },
    publisher: {
      "@type": "Organization",
      name: "EBS Software Solution",
      url: siteUrl,
    },
    offers: {
      "@type": "AggregateOffer",
      priceCurrency: "INR",
      lowPrice: "65000",
      highPrice: "125000",
      offerCount: "2",
      availability: "https://schema.org/InStock",
    },
    featureList: [
      "Hotel PMS software",
      "Hotel front office management",
      "Room reservation and availability",
      "Check-in and checkout management",
      "Restaurant POS and GST billing",
      "KOT and Android ordering app",
      "QR code digital menu",
      "Hotel inventory and purchase management",
      "Recipe costing and kitchen stock control",
      "Banquet management",
      "Laundry management",
      "Hotel accounting and guest ledger",
      "HR and face recognition attendance",
    ],
    keywords: seoKeywords.join(", "),
  };

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqList.map((item) => ({
      "@type": "Question",
      name: item.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: item.answer,
      },
    })),
  };

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Home",
        item: siteUrl,
      },
      {
        "@type": "ListItem",
        position: 2,
        name: "HotelSof PMS Software",
        item: pageUrl,
      },
    ],
  };

  const handleImageError = (event) => {
    event.currentTarget.style.display = "none";
  };

  return (
    <main className="hotel-detail-page">
      <Helmet>
        <meta charSet="utf-8" />

        <title>{seoTitle}</title>
        <meta name="description" content={seoDescription} />
        <meta name="keywords" content={seoKeywords.join(", ")} />

        <link rel="canonical" href={pageUrl} />

        <meta name="robots" content="index, follow, max-image-preview:large" />
        <meta name="author" content="EBS Software Solution" />
        <meta name="language" content="English" />

        <meta property="og:type" content="website" />
        <meta property="og:title" content={seoTitle} />
        <meta property="og:description" content={seoDescription} />
        <meta property="og:url" content={pageUrl} />
        <meta property="og:image" content={heroImageUrl} />
        <meta property="og:site_name" content="EBS Software Solution" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={seoTitle} />
        <meta name="twitter:description" content={seoDescription} />
        <meta name="twitter:image" content={heroImageUrl} />

        <script type="application/ld+json">
          {JSON.stringify([softwareSchema, faqSchema, breadcrumbSchema])}
        </script>
      </Helmet>

      <section className="hotel-hero">
        <img
          className="hotel-hero-bg"
          src={web5}
          alt="HotelSof hotel PMS software and restaurant POS software for room reservation billing inventory and accounting"
          onError={handleImageError}
        />
        <div className="hotel-hero-overlay"></div>

        <Container className="hotel-hero-container">
          <Row className="align-items-center g-4">
            <Col lg={7}>
              <div className="hotel-hero-content">
                <div className="hotel-kicker">
                  Hotel PMS / Restaurant POS Software
                </div>
                <h1>HotelSof</h1>
                <h2>
                  GST Enabled Hotel PMS Software for Hotels, Resorts and Restaurants
                </h2>
                <p>
                  HotelSof is a complete hotel PMS software and restaurant POS
                  software for room reservation, check-in, checkout, front
                  office, restaurant billing, KOT, QR menu, inventory,
                  accounting, banquet, laundry and HR operations.
                </p>

                <div className="hotel-hero-actions">
                  <a
                    href="#hotel-features"
                    className="hotel-btn hotel-btn-primary"
                  >
                    View Features
                  </a>
                  <Link
                    to="/EmailContactForm"
                    className="hotel-btn hotel-btn-outline"
                  >
                    Request Demo
                  </Link>
                </div>
              </div>
            </Col>

            <Col lg={5}>
              <div className="hotel-price-card">
                <span>HotelSof PMS Software Pricing</span>
                <strong>Choose the right edition for your hotel or restaurant</strong>

                <div className="hotel-price-list">
                  {pricingOptions.map((item) => (
                    <div className="hotel-price-item" key={item.title}>
                      <div>
                        <h4>{item.title}</h4>
                        <p>{item.note}</p>
                      </div>

                      <div className="hotel-price-amount">
                        {item.price}
                        {item.terms && (
                          <small className="hotel-price-terms">
                            * Terms & conditions apply
                          </small>
                        )}
                      </div>
                    </div>
                  ))}
                </div>

                <p className="hotel-price-footer">
                  Designed for hotels, motels, resorts and integrated restaurant
                  operations with scalable PMS, POS, inventory and accounting modules.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="hotel-stats-section">
        <Container>
          <Row className="g-3">
            {quickStats.map((item) => (
              <Col lg={3} md={6} key={item.label}>
                <div className="hotel-stat-card">
                  <strong>{item.value}</strong>
                  <span>{item.label}</span>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      <section className="hotel-overview-section">
        <Container>
          <Row className="g-4 align-items-center">
            <Col lg={6}>
              <div className="hotel-section-label">Overview</div>
              <h2 className="hotel-section-title">
                Complete PMS for hotel, resort and restaurant operations
              </h2>
              <p className="hotel-text">
                HotelSof provides an integrated hotel management software suite
                for property management and hospitality operations. It manages
                every major part of hotel workflow from room reservation, front
                office, guest ledger and housekeeping to food and beverage POS,
                inventory, accounting and management reporting.
              </p>
              <p className="hotel-text">
                Whether you run a small hotel, resort, motel or full-service
                restaurant property, HotelSof is built to scale with flexible
                tariff, GST billing, restaurant KOT, QR code menu, recipe
                costing, inventory, financial accounting and operational modules.
              </p>
            </Col>

            <Col lg={6}>
              <div className="hotel-overview-card">
                <h3>HotelSof covers</h3>
                <div className="hotel-overview-grid">
                  <div><span>✓</span><p>Room Reservation</p></div>
                  <div><span>✓</span><p>Check-in / Checkout</p></div>
                  <div><span>✓</span><p>Restaurant POS</p></div>
                  <div><span>✓</span><p>Housekeeping</p></div>
                  <div><span>✓</span><p>Inventory</p></div>
                  <div><span>✓</span><p>Accounting</p></div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="hotel-seo-section">
        <Container>
          <div className="hotel-heading-center">
            <div className="hotel-section-label">Why Choose HotelSof</div>
            <h2 className="hotel-section-title">
              Hotel PMS software built for reservation, billing, restaurant POS and accounting
            </h2>
            <p>
              HotelSof is designed for hotels, resorts, motels, restaurants and
              hospitality businesses that need one software for front office,
              PMS, POS, inventory, banquet, laundry, HR and financial control.
            </p>
          </div>

          <Row className="g-4">
            {seoPainPoints.map((item) => (
              <Col lg={3} md={6} key={item.title}>
                <div className="hotel-seo-card">
                  <h3>{item.title}</h3>
                  <p>{item.text}</p>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      <section className="hotel-features-section" id="hotel-features">
        <Container>
          <div className="hotel-heading-center">
            <div className="hotel-section-label">Key Features</div>
            <h2 className="hotel-section-title">
              Powerful features for smooth hospitality management
            </h2>
            <p>
              HotelSof brings hotel PMS, front office, restaurant POS,
              inventory, accounts, banquet, laundry, SMS, QR ordering and HR
              attendance into one integrated platform.
            </p>
          </div>

          <Row className="g-4">
            {coreFeatures.map((feature, index) => (
              <Col lg={4} md={6} key={feature.title}>
                <div className="hotel-feature-card">
                  <div className="hotel-feature-number">
                    {String(index + 1).padStart(2, "0")}
                  </div>
                  <h3>{feature.title}</h3>
                  <p>{feature.text}</p>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      <section className="hotel-operations-section">
        <Container>
          <Row className="g-4 align-items-start">
            <Col lg={5}>
              <div className="hotel-section-label">Front Office Reports</div>
              <h2 className="hotel-section-title">
                Daily operational control and reporting
              </h2>
              <p className="hotel-text">
                HotelSof helps front office and management teams track room
                activity, booking status, occupancy, guest ledger, room sales,
                GST billing and operational analysis with practical hotel PMS reports.
              </p>
            </Col>

            <Col lg={7}>
              <div className="hotel-operation-list">
                {operations.map((item) => (
                  <div key={item}>
                    <span>✓</span>
                    <p>{item}</p>
                  </div>
                ))}
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="hotel-modules-section">
        <Container>
          <div className="hotel-heading-center">
            <div className="hotel-section-label">Operational Modules</div>
            <h2 className="hotel-section-title">
              Integrated modules for complete hotel ERP
            </h2>
            <p>
              HotelSof connects financial accounting, SMS alerts, banquet
              management, laundry management, restaurant POS and hotel PMS
              modules for professional hospitality operations.
            </p>
          </div>

          <Row className="g-4">
            {hospitalityModules.map((module) => (
              <Col lg={6} key={module.title}>
                <div className="hotel-module-card">
                  <h3>{module.title}</h3>
                  <p>{module.text}</p>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      <section className="hotel-advanced-section">
        <Container>
          <Row className="g-4">
            <Col lg={5}>
              <div className="hotel-advanced-title">
                <div className="hotel-section-label">Advanced Technology</div>
                <h2 className="hotel-section-title">
                  QR menu, Android ordering and face recognition attendance
                </h2>
                <p>
                  HotelSof includes modern digital tools for contactless guest
                  experience, mobile restaurant ordering, room service ordering,
                  hotel HR and employee attendance control.
                </p>
              </div>
            </Col>

            <Col lg={7}>
              <Row className="g-3">
                {advancedFeatures.map((feature) => (
                  <Col md={6} key={feature.title}>
                    <div className="hotel-advanced-card">
                      <span>✓</span>
                      <h3>{feature.title}</h3>
                      <p>{feature.text}</p>
                    </div>
                  </Col>
                ))}
              </Row>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="hotel-faq-section">
        <Container>
          <div className="hotel-heading-center">
            <div className="hotel-section-label">FAQ</div>
            <h2 className="hotel-section-title">
              Questions about HotelSof PMS and restaurant software
            </h2>
            <p>
              Important information for hotels and restaurants looking for PMS,
              POS, billing, reservation, inventory, banquet, laundry and
              accounting software.
            </p>
          </div>

          <div className="hotel-faq-list">
            {faqList.map((item) => (
              <div className="hotel-faq-item" key={item.question}>
                <h3>{item.question}</h3>
                <p>{item.answer}</p>
              </div>
            ))}
          </div>
        </Container>
      </section>

      <section className="hotel-cta-section">
        <Container>
          <div className="hotel-cta-card">
            <div>
              <span>Ready to manage your hotel professionally?</span>
              <h2>Use HotelSof for PMS, POS, inventory and accounting.</h2>
              <p>
                Get a GST-enabled hotel PMS software and restaurant POS software
                with front office, room reservation, restaurant billing, KOT, QR
                menu, banquet, laundry, HR and accounting modules.
              </p>
            </div>
            <Link to="/EmailContactForm" className="hotel-btn hotel-btn-light">
              Request Demo
            </Link>
          </div>
        </Container>
      </section>

      <section className="hotel-corporate-keywords-section">
        <Container>
          <div className="hotel-corporate-keywords-head">
            <div className="hotel-section-label">Related Solutions</div>
            <h2>Hotel PMS, restaurant POS and hospitality software search terms</h2>
            <p>
              HotelSof covers important hotel, restaurant and hospitality
              software requirements with professional PMS, POS, billing,
              reservation, inventory, accounting and operational modules.
            </p>
          </div>

          <Row className="g-4">
            {relatedSearchGroups.map((group) => (
              <Col lg={6} key={group.title}>
                <div className="hotel-corporate-keyword-card">
                  <h3>{group.title}</h3>
                  <p>{group.text}</p>

                  <div className="hotel-corporate-keyword-list">
                    {group.terms.map((term) => (
                      <span key={term}>{term}</span>
                    ))}
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
    </main>
  );
};

export default Hotelsof;